/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
    Team,
    TeamFromJSON,
    TeamFromJSONTyped,
    TeamToJSON,
} from './';

/**
 * 
 * @export
 * @interface TeamsListResponse
 */
export interface TeamsListResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof TeamsListResponse
     */
    msg: string;
    /**
     * 
     * @type {Array<Team>}
     * @memberof TeamsListResponse
     */
    entries: Array<Team>;
}

export function TeamsListResponseFromJSON(json: any): TeamsListResponse {
    return TeamsListResponseFromJSONTyped(json, false);
}

export function TeamsListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamsListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entries': ((json['entries'] as Array<any>).map(TeamFromJSON)),
    };
}

export function TeamsListResponseToJSON(value?: TeamsListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entries': ((value.entries as Array<any>).map(TeamToJSON)),
    };
}


